import type { NotificationType } from '@/types/notification';

export const NOTIFICATION_TYPE = {
  PROJECT: 'PROJECT',
  TASK: 'TASK',
  COMMENT: 'COMMENT',
  REMINDER: 'REMINDER',
  SYSTEM: 'SYSTEM',
} as const satisfies Record<string, NotificationType>;

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  PROJECT: '项目',
  TASK: '任务',
  COMMENT: '点评',
  REMINDER: '催办',
  SYSTEM: '系统',
};

export function notificationTypeTagClass(type: NotificationType): string {
  switch (type) {
    case NOTIFICATION_TYPE.PROJECT:
      return 'mobile-tag mobile-tag--primary';
    case NOTIFICATION_TYPE.TASK:
      return 'mobile-tag mobile-tag--warning';
    case NOTIFICATION_TYPE.COMMENT:
      return 'mobile-tag mobile-tag--success';
    default:
      return 'mobile-tag';
  }
}
